module.exports = __webpack_public_path__ + "img/btn-bg-white-sloped.784e7d0c.svg";